import type { Translation } from "../i18n-types";

const es = {
	WELCOME_LONG: "Bienvenido a Unicorn Digital Courtroom",
	WELCOME: "¡Bienvenido {name}!",
	JOIN_ROOM_DESCRIPTION: "Únete a una sala de la lista o crea tu propia sala",
	NO_ROOM: "¿No ves la sala que estás buscando? Crea tu propia sala",
	CREATE_ROOM: "Crear Sala",
	ROOM: "Sala",
	ACCESSIBILITY_SETTINGS: "Configuración de accesibilidad",
	ACCESSIBILITY_SETTINGS_DESCRIPTION:
		"Cambie la configuración de accesibilidad aquí",
	CONTRAST: "Contraste",
	SELECT_DISPLAY_NAME: "Por favor, ingresa el nombre que deseas usar",
	SOMETHING_WENT_WRONG: "¡Ups! Algo salió mal",
	GO_BACK: "Volver",
	GO_BACK_TO_ROOM: "Volver a la Sala",
	EXPAND: "Expandir",
	EXPORT: "Exportar",
	JOIN_ROOM: "Unirse a la Sala",
	ROOM_ENDED_TITLE: "Sala Finalizada",
	ROOM_ENDED_DESCRIPTION:
		"La sala ha finalizado, serás redirigido a la pantalla principal",
	RENAME_FAILED: "Error al cambiar el nombre",
	TRANSCRIPT_DISCLAIMER:
		"Una transcripción basada en los hablantes identificados. Debes hablar durante más de 7 segundos para ser identificado",
	CHANGE_SPEAKER_TITLE: "Cambiar Hablante",
	CHANGE_SPEAKER_DESCRIPTION: "cambiar el nombre y color del hablante aquí",
	PREVIEW_MESSAGE: "Este es un mensaje de vista previa",
	COLOR: "Color",
	NAME: "Nombre",
	LANGUAGE: "Idioma",
	CANCEL: "Cancelar",
	SAVE: "Guardar",
	ROOM_ID: "ID de Sala",
	ROOM_ID_FORM_PLACEHOLDER: "Ingresa la ID de la sala para unirte",
	ROOM_ID_FORM_REQUIRED: "La ID de la sala es requerida para unirse",
	ROOM_ID_FORM_MIN_LENGTH: "La ID de la sala debe tener 17 caracteres",
	LOGIN: "Iniciar Sesión",
	ROOM_COL: "Sala:",
	LANGUAGE_COL: "Idioma",
	END_ROOM: "Finalizar Sala",
	JOIN_NOW: "Unirse Ahora",
	LOGIN_FORM: {
		TOAST_TITLE: "¡Inicio de sesión exitoso!",
		TOAST_DESCRIPTION: "Ahora puedes crear/unirte a una sala",
		DISPLAY_NAME: "Nombre de Usuario",
		DISPLAY_NAME_FORM_PLACEHOLDER: "Ingresa el nombre visible",
		DISPLAY_NAME_FORM_SHORT:
			"El nombre de usuario debe tener al menos 3 caracteres",
		DISPLAY_NAME_FORM_LONG:
			"El nombre de usuario debe tener como máximo 32 caracteres",
		DISPLAY_NAME_FORM_REQUIRED: "Se requiere un nombre de usuario",
	},
	PROFILE_FORM: {
		TITLE: "Completa tu Perfil",
		DESCRIPTION: "Por favor, ingresa tu nombre de usuario para empezar",
		TOAST_SUCCESS_TITLE: "¡Perfil Actualizado!",
		TOAST_SUCCESS_DESCRIPTION: "Tu perfil se ha guardado exitosamente.",
		TOAST_ERROR_TITLE: "Error de Actualización",
		TOAST_ERROR_DESCRIPTION:
			"No se pudo actualizar tu perfil. Por favor, inténtalo de nuevo.",
		SUBMIT_BUTTON: "Guardar Perfil",
	},
	DIARIZATION: {
		UNDETECTED: "No detectado",
		ACCURACY: "Precisión",
		ID: "ID",
		LEXICAL: "Lexical",
		ITN: "ITN",
		MASKED_ITN: "ITN máscara",
		LANGUAGE: "Idioma",
		ORIGINAL_TEXT: "Texto Original",
		SPEAKER: "Hablante",
	},
	NO_ROOMS_LIST: "Oops, no se pueden encontrar salas.",
	SEARCH_FOR_A_ROOM: "Buscar una sala",
	AUTH_ERROR_DESCRIPTION:
		"Hubo un problema al autenticarte. Por favor, actualiza la página.",
	DELETE_CONFIRMATION_MODAL: {
		TITLE: "Eliminar Sala",
		DESCRIPTION: "¿Estás seguro de que deseas eliminar esta sala?",
		CANCEL: "Cancelar",
		DELETE: "Eliminar",
	},
	CREATE_ROOM_TOAST: {
		TITLE: "Sala creada",
		DESCRIPTION: "Tu sala está lista para unirte.",
	},
	CREATE_ROOM_FORM: {
		DESCRIPTION: "Define un nombre para tu sala para que otros lo vean.",
		NAME_LABEL: "Nombre de la Sala",
		NAME_PLACEHOLDER: "Escribe el nombre de la sala",
		LANGUAGE: "Idioma",
		LANGUAGE_PLACEHOLDER: "Selecciona un idioma",
		AUTO_DETECT: "Auto Detectar",
		ENGLISH_US: "Inglés (Estados Unidos)",
		ENGLISH_IN: "Inglés (India)",
		ARABIC_KSA: "Árabe (Arabia Saudita)",
		SPANISH_CR: "Español (Costa Rica)",
		CATALAN_ES: "Catalán (España)",
		PORTUGUESE_PT: "Portugués (Portugal)",
		PORTUGUESE_BR: "Portugués (Brasil)",
		ESTONIAN_EE: "Estonio (Estonia)",
		RUSSIAN_RU: "Ruso (Rusia)",
		MALTESE_MT: "Maltés (Malta)",
		FILIPINO_PH: "Filipino (Filipinas)",
		SPANISH_MX: "Español (México)",
		CHINESE_CN: "Chino (Mandarín)",
		VIETNAMESE_VN: "Vietnamita (Vietnam)",
		KOREAN_KR: "Coreano (Corea)",
		HINDI_IN: "Hindi (India)",
		PERSIAN_IR: "Persa (Irán)",
		LANGUAGE_DESCRIPTION:
			"Selecciona un idioma para la sala, no podrás cambiar el idioma más tarde.",

		INCPERSONDEFAULT: "Doe,Jane",
		CDCDEFAULT: "AB1234",
		HEARINGTYPEDEFAULT: "Audiencia de idoneidad posterior",
		SCHEDULEDEFAULT: "28/11/2023, 10:30 a. m. (hora del Pacífico)",
		ADVANCED: "Ajustes avanzados",
		INCARCERATED_PERSON_PLACEHOLDER: "Introduzca su nombre",
		CDC_PLACEHOLDER: "Ingrese el número de CDC",
		HEARING_TYPE_PLACEHOLDER: "Introduzca el tipo de audiencia",
		INCARCERATED_PERSON: "Persona encarcelada",
		CDC: "CDC",
		HEARING_TYPE: "Tipo de audiencia",
		SCHEDULE: "Cronograma",
		PICKDATE: "Elija una fecha",
		STEP_DETAILS: "Detalles",
		STEP_MODEL: "Modelo",
		CONTINUE: "Continuar",
		BACK: "Atrás",
		MODEL_TITLE: "Modelo de transcripción",
		MODEL_DESCRIPTION: "Choose the model everyone in this room starts with. You can lock it so participants keep it.",
		LOCK_MODEL: "Lock model for everyone",
		LOCK_MODEL_DESC: "Participants cannot change the transcription model in this room.",
		HOURS: "Horas",
		MINUTES: "Minutos",
		SECONDS: "Segundos",
	},
	EXPORT_MODAL: {
		TOAST_FAILED_TITLE: "Error al Exportar",
		TOAST_FAILED_DESCRIPTION: "No se puede exportar una transcripción vacía.",
		DOWNLOAD: "Descargar",
		DOWNLOAD_DESCRIPTION:
			"Selecciona el formato para la exportación y habilita opciones adicionales.",
		SELECT_FORMAT: "Selecciona el formato",
		SELECT_FORMAT_PLACEHOLDER: "Selecciona el formato de exportación",
		DOCUMENT: "Documento (.pdf)",
		SPREADSHEET: "Hoja de Cálculo (.csv)",
		AUDIO: "Audio (.mp3)",
		DOCX: "Documento Word (.docx)",
	},
	TRANSLATE_DIALOG: {
		TITLE: "Traducción",
		BODY: "¿Quieres aplicar este cambio a todas las transcripciones de este usuario?",
		APPLY_TO_SPEAKER: "Aplicar solo a este usuario",
		APPLY_ONCE: "Aplicar solo aquí",
		APPLY_TO_ALL: "Aplicar a todos los usuarios",

		TRANSLATE: "Traducir",
	},
	GUEST_FORM: {
		TITLE: "Acceso de Invitado",
		DESCRIPTION:
			"Ingresa tu dirección de correo electrónico para recibir un enlace de inicio de sesión seguro",
		EMAIL_LABEL: "Dirección de Correo Electrónico",
		EMAIL_PLACEHOLDER: "Ingresa la dirección de correo electrónico",
		EMAIL_REQUIRED: "La dirección de correo electrónico es requerida",
		EMAIL_INVALID:
			"Por favor, ingresa una dirección de correo electrónico válida",
		SEND_LINK: "Enviar Enlace de Inicio de Sesión",
		SUCCESS_TITLE: "Revisa tu Correo Electrónico",
		SUCCESS_DESCRIPTION:
			"Hemos enviado un enlace de inicio de sesión a tu dirección de correo electrónico. Haz clic en el enlace para acceder a la sala.",
		ERROR_TITLE: "Algo salió mal",
		ERROR_DESCRIPTION:
			"Error al enviar el enlace de inicio de sesión. Por favor, inténtalo de nuevo.",
		CANCEL: "Cancelar",
	},
	START_DATE_TIME: "Fecha y Hora de Inicio",
	END_DATE_TIME: "Fecha y Hora de Finalización",
	REVERT_TO_ORIGINAL: "Volver al Original",
	SELECTED_LANGUAGE: "Idioma seleccionado",
	TRANSLATION_INFO: "Algunas transcripciones han sido traducidas del original.",
	INVITE_GUEST: "Invitar Invitado",
	INVITE_GUEST_DESCRIPTION:
		"Invitar a un usuario invitado a la sala ingresando su nombre y dirección de correo electrónico",
	CREATED_BY: "Creado por",
	VIEW_ALL: "Ver todo",
	LOBBY: {
		LOBBY: "Vestíbulo",
		WAITING_IN_LOBBY: "{name} está esperando en el vestíbulo",
		USERS_WAITING_IN_LOBBY:
			"Gestionar los usuarios que están esperando actualmente en el vestíbulo.",
		SEND_INVITE: "Enviar invitación",
		ADMIT: "Permitir",
		REJECT: "Rechazar",
		NO_PARTICIPANTS: "No hay participantes en el vestíbulo.",
	},
	CLOSE: "Cerrar",
	LOGIN_PAGE: {
		CAROUSEL_STORY_1:
			"Experimenta la transcripción en tiempo real con tecnología avanzada de reconocimiento de hablantes. Perfecto para reuniones, entrevistas y conferencias.",
		CAROUSEL_STORY_2:
			"El modo de alto contraste, fuentes personalizables y soporte multiidioma aseguran que todos puedan usar nuestra plataforma de manera efectiva.",
		CAROUSEL_STORY_3:
			"Tus conversaciones están protegidas con seguridad de nivel empresarial. Únete a miles de profesionales que confían en uTranscribe.",
		CAROUSEL_STORY_4:
			"Elige tu método de identificación a continuación y comienza a transcribir en segundos. No se requiere configuración compleja.",
		CDCR_TEAM_TITLE: "Equipo Tech Unicorn",
		CDCR_TEAM_SUBTITLE: "Miembro Verificado",
		OR_CONTINUE_WITH: "o continúa con",
		GUEST_ACCESS_SUBTITLE: "¿No eres miembro? Únete usando tu ID de reunión",
		WELCOME_TO: "Bienvenido a",
		CHOOSE_IDENTIFICATION: "Por favor elige tu identificación",
		NEED_HELP: "¿Necesitas ayuda? Conéctate con nuestro Servicio de Soporte.",
		CALL_SUPPORT: "Llama al 1-877-742-2135",
		EMAIL_SUPPORT: "Escribe a support@courtroom.tech",
	},
	SIZES: "Tamaños",
	DIAGNOSTICS: "Diagnósticos",
	ROOM_BACKGROUND: "Fondo de la sala",
	NOT_AVAILABLE: "No disponible",
	UNRECOGNIZED_SPEECH: "No reconocido",
	UNRECOGNIZED_SPEECH_TOOLTIP:
		"Esta transcripción no está reconocida. Por favor, verifica la calidad del audio y vuelve a intentarlo.",
	UNDETECTED: "No detectado",
	MICROPHONE_QUALITY_WARNING:
		"Por favor, verifica la calidad de tu micrófono para mejorar la precisión o ajusta la distancia del micrófono",
	LOW_ACCURACY_WARNING: "Precisión baja",
	UNKNOWN: "Desconocido",
	TRANSCRIPTION_SETTINGS: {
		TRANSCRIPTION_SETTINGS: "Configuración de transcripción",
		GENERAL: "General",
		GENERAL_HINT: "Tema, fuente e idioma",
		MODE_HINT: "Comportamiento de transcripción",
		MODEL_HINT: "Motor de procesamiento IA",
		MODE: "Modo",
		LIVE_TRANSCRIPTION: "Transcripción en vivo",
		SEGMENTED_TRANSCRIPTION: "Transcripción segmentada",
		FINAL_TRANSCRIPTION: "Transcripción final",
		LIVE_DESC:
			"Vea una transcripción en vivo de su propio discurso en un panel separado mientras habla. El panel principal muestra la transcripción final de todos los oradores.",
		SEGMENTED_DESC:
			"Muestra transcripciones temporales segmentadas en tiempo real, actualizándose automáticamente a la versión final.",
		FINAL_DESC:
			"Muestra solo la transcripción final en el panel principal. No se muestra la transcripción en vivo.",
		SPEED_VALUE: "Velocidad: {value}x",
		SPEED: "Velocidad",
		FONT_TEST:
			"UTranscribe está revolucionando la forma en que capturamos y entendemos el habla.",
		FONT_SIZE: "Tamaño de fuente",
		SPEED_DESC: "Velocidad y retraso de transcripción",
		DELAY_DESC: "Velocidad {speed}x = retraso de {delay} segundos",
		MODEL: "Modelo",
		MODEL_TITLE: "Modelo de Transcripción",
		MODEL_DESC: "Seleccione el modelo de IA utilizado para procesar sus transcripciones.",
		MODEL_DEFAULT: "Predeterminado",
		MODEL_WHISPER: "Allicorn Model 1",
		MODEL_GPT4O: "Allicorn Model 2",
		MODEL_GPT4O_MINI: "Allicorn Model 3",
		MODEL_FAST: "Allicorn Model 4",
		MODEL_DEFAULT_DESC:
			"Servicio de diarización de Microsoft con procesamiento rápido y precisión confiable para la mayoría de los casos de uso.",
		MODEL_DEFAULT_SHORT_DESC:
			"Diarización de hablantes rápida y confiable para la mayoría de los casos de uso.",
		MODEL_WHISPER_DESC:
			"Allicorn Model 1 con precisión mejorada para entornos de audio complejos y vocabulario especializado.",
		MODEL_WHISPER_SHORT_DESC:
			"Alta precisión para audio complejo y términos especializados.",
		MODEL_GPT4O_DESC:
			"Modelo de transcripción Allicorn Model 2 con máxima precisión y comprensión del lenguaje.",
		MODEL_GPT4O_SHORT_DESC:
			"Máxima precisión de transcripción y comprensión del lenguaje.",
		MODEL_GPT4O_MINI_DESC:
			"Modelo de transcripción Allicorn Model 3 que equilibra precisión y velocidad.",
		MODEL_GPT4O_MINI_SHORT_DESC:
			"Precisión y velocidad de transcripción equilibradas.",
		MODEL_FAST_DESC:
			"Servicio de transcripción Allicorn Model 4 optimizado para procesamiento de baja latencia.",
		MODEL_FAST_SHORT_DESC:
			"Procesamiento de transcripción de baja latencia.",
		MODEL_ENHANCED: "Mejorado",
		MODEL_PREMIUM: "Premium",
		MODEL_BETA: "Beta",
		MODEL_BETA_TOOLTIP: "This feature is currently in beta. Expect occasional inaccuracies as we continue fine-tuning.",
		MODEL_LOCKED: "Model locked",
		MODEL_LOCKED_DESC: "The host fixed the transcription model when this room was created.",
		MODEL_LOCKED_HINT: "Locked by the room host.",
		DOMAIN_MATH_UNAVAILABLE: "Not available for the selected model.",
		DOMAIN_MATH: "Optimizado para matemáticas",
		DOMAIN_MATH_DESC:
			"Muestra los símbolos y ecuaciones matemáticas habladas como notación matemática real en lugar de texto plano.",
	},
	NO_AUDIO: "No se detectó audio",
	NO_AUDIO_DESC:
		"Tu micrófono está activado, pero no se detecta ningún audio. Verifica la configuración del micrófono o cambia a otro micrófono.",
	NO_TRANSCRIPTION: "No se generaron transcripciones",
	NO_TRANSCRIPTION_DESC:
		"No se están generando transcripciones. Por favor, actualiza la página.",
	SCROLLING_PAUSED: "Desplazamiento hacia abajo pausado",
	RESUME: "Reanudar",
} satisfies Translation;

export default es;
